import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import notify from 'devextreme/ui/notify';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class ToasterInterceptorService implements HttpInterceptor {
  constructor(private translocoService: TranslocoService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!this.errorCodeHandling(error)) {
          return throwError(() => error);
        }
        return of();
      })
    );
  }

  private errorCodeHandling(error: HttpErrorResponse): boolean {
    switch (error.status) {
      case 0: {
        if (error.url?.includes('serverinfo/health')) {
          // not show message
        }
        break;
      }
      case 200: {
        if (error.url?.includes('serverinfo/health')) {
          // not show message
        }
        break;
      }

      case 400: {
        if (error.url?.includes('attachments/v2/pdfs/')) {
          return true;
        }
        if (error.url?.includes('auth/validate')) {
          notify({
            message: this.translocoService.translate('validations.interceptorService.notAbleToLogin'),
            type: 'error',
            displayTime: 5000,
          });
          break;
        }
        notify({
          message: this.translocoService.translate('validations.interceptorService.unknownErrorCode', { value: error.message }),
          type: 'error',
          displayTime: 5000,
        });
        break;
      }
      case 401: {
        if (error.url?.includes('auth/validate2factor')) {
          notify({
            message: this.translocoService.translate('validations.interceptorService.login2FAFailed'),
            type: 'error',
            displayTime: 5000,
          });
        } else if (error.url?.includes('auth/validate')) {
          notify({
            message: this.translocoService.translate('validations.interceptorService.loginFailed'),
            type: 'error',
            displayTime: 5000,
          });
        } else if (error.url?.includes('auth/me')) {
          break;
        } else {
          notify({
            message: this.translocoService.translate('validations.interceptorService.sessionExpired'),
            type: 'warning',
            displayTime: 5000,
          });
        }

        break;
      }
      case 403: {
        if (error.url?.includes('auth/verifysecondfactor')) {
          break;
        }
        notify({
          message: this.translocoService.translate('validations.interceptorService.notEnoughPermissions'),
          type: 'error',
          displayTime: 5000,
        });
        break;
      }
      case 404: {
        //don't show error if user-method is not implemented by server
        if (error.url?.includes('auth/user-method')) {
          break;
        }
        if (error.url?.includes('ecg/pdf')) {
          notify({
            message: this.translocoService.translate('validations.interceptorService.pdfNotAvailable'),
            type: 'warning',
            displayTime: 5000,
          });
        } else {
          notify({
            message: this.translocoService.translate('unknownServerError'),
            type: 'error',
            displayTime: 5000,
          });
        }
        break;
      }
      // Should be handled in the component that made the request
      case 409:
        break;
      case 500: {
        if (error.url?.includes('email/send')) {
          //should be handled in the component that made the request
          break;
        }
        notify({
          message: this.translocoService.translate('unknownServerError'),
          type: 'error',
          displayTime: 5000,
        });
        break;
      }
      default:
        notify({
          message: this.translocoService.translate('validations.interceptorService.unknownErrorCode', { value: error.message }),
          type: 'error',
          displayTime: 5000,
        });
    }
    return false;
  }
}
